import styled from 'styled-components';

export const EbonBillContainer = styled.main`
    margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/bill/DownloadEbonBillPageStyle.js